import React from "react";
import styled from "styled-components";

import ModalBasic from "./ModalBasic.jsx";
import { getLowActionConflictMessage } from "../../utils/lowAction.js";

const ModalLowActionInProgress = ({ conflict, onClose }) => (
  <ModalBasic
    isOpen={Boolean(conflict)}
    onClose={onClose}
    width={window.innerWidth > 430 ? "352px" : "266px"}
    padding={window.innerWidth > 430 ? "24px" : "23px"}
  >
    <Content role="alertdialog" aria-live="assertive">
      <Title>{getLowActionConflictMessage(conflict)}</Title>
      <Description>완료 후 다시 시도해 주세요.</Description>
      <ButtonWrapper>
        <ConfirmButton type="button" onClick={onClose}>
          확인
        </ConfirmButton>
      </ButtonWrapper>
    </Content>
  </ModalBasic>
);

const Content = styled.div`
  color: #000;
`;

const Title = styled.div`
  margin: 8px 8px 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;

  @media (max-width: 430px) {
    margin: 3px 1px 0;
    font-size: 16px;
    line-height: 26px;
  }
`;

const Description = styled.div`
  margin: 0 8px 18px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;

  @media (max-width: 430px) {
    margin: 0 1px 16px;
    font-size: 14px;
    line-height: 22px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 8px;

  @media (max-width: 430px) {
    margin-right: 1px;
  }
`;

const ConfirmButton = styled.button`
  width: 70px;
  height: 40px;
  padding: 8px 16px;
  border: 0;
  border-radius: 6px;
  background: #000;
  color: #00f370;
  cursor: pointer;
`;

export default ModalLowActionInProgress;

